import {
  emptyString,
  loginConstants,
  successMessages,
  userPermissionsConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { userPermissionsService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";
import { loginActions } from "../../../../redux/actions/login.actions";
import { storeActions } from "../../../admin-screens/redux/actions/stores.actions";

//Destructuring user permission constants
const {
  USER,
  PERMISSION_DATA,
  VERIFY_PASSWORD,
  USER_PERMISSION_DATA,
  UPDATE_USER_PERMISSION,
  USER_PERMISSION_DELETED,
  RESET_PASSWORD_USER_PERMISSION,
  RESET_PASSWORD_USER_PERMISSION_SPINNER,
  GET_USER_PERMISSION_EMAILS,
} = userPermissionsConstants;

const {
  UPDATED_SUCCESSFULLY,
  REINVITE_SUCCESSFULLY,
  RESET_PASSWORD_SUCCESS,
  USER_CREATION_AND_VERIFICATION,
} = successMessages;

//Function to resend create password email
const resendCreatePasswordEmail = (userId) => {
  return (dispatch) => {
    withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .resendCreatePasswordEmail(userId)
        .then(
          (_response) => {
            customToast(REINVITE_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};
const addUserPermission = (data) => {
  return (dispatch) => {
    return withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .addUserPermission(data)
        .then(
          (response) => {
            customToast(
              USER_CREATION_AND_VERIFICATION,
              toastTypes.SUCCESS,
              10000
            );
            dispatch(success(response, USER_PERMISSION_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Fetching user permission paginated data
const getUsers = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .getUsers(body)
        .then(
          (response) => {
            dispatch(success(response, PERMISSION_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to update user data
const updateUsers = (body, userId, isUserProfile = false) => {
  return (dispatch) => {
    withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .updateUsers(body)
        .then(
          (response) => {
            dispatch(success(response, UPDATE_USER_PERMISSION));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
            if (!isUserProfile) dispatch(loginActions.getUserById(userId));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to delete user details
const deleteUserDetails = (userId) => {
  return (dispatch) => {
    return withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .deleteUserDetails(userId)
        .then(
          (response) => {
            customToast(successMessages.REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(success(response, USER_PERMISSION_DELETED));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Reset Password in user permission
const resetPassword = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, RESET_PASSWORD_USER_PERMISSION_SPINNER, () =>
      userPermissionsService
        .resetPassword(body)
        .then(
          (_response) => {
            dispatch(
              success(RESET_PASSWORD_SUCCESS, RESET_PASSWORD_USER_PERMISSION)
            );
            customToast(RESET_PASSWORD_SUCCESS, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Reset Password in user permission
const resetPasswordResponseMsg = () => {
  return (dispatch) => {
    dispatch(failure(emptyString, RESET_PASSWORD_USER_PERMISSION));
  };
};

//Reset Password in user permission
const resetVerifyPassworddResponseMsg = () => {
  return (dispatch) => {
    dispatch(failure(emptyString, VERIFY_PASSWORD));
  };
};

//Getting permission emails against brandId
const getUserPermissionByBrandId = (brandId) => {
  return (dispatch) => {
    userPermissionsService.getUserPermissionByBrandId(brandId).then(
      (response) => {
        dispatch(success(response, GET_USER_PERMISSION_EMAILS));
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
        dispatch(failure(error, GET_USER_PERMISSION_EMAILS));
      }
    );
  };
};

//Getting permission emails against groupId
const getUserPermissionByGroupId = (groupId) => {
  return (dispatch) => {
    userPermissionsService.getUserPermissionByGroupId(groupId).then(
      (response) => {
        dispatch(success(response, GET_USER_PERMISSION_EMAILS));
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
        dispatch(failure(error, GET_USER_PERMISSION_EMAILS));
      }
    );
  };
};

//Getting permission emails against managerId
const getUserPermissionByManagerId = (managerId) => {
  return (dispatch) => {
    userPermissionsService.getUserPermissionByManagerId(managerId).then(
      (response) => {
        dispatch(success(response, GET_USER_PERMISSION_EMAILS));
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
        dispatch(failure(error, GET_USER_PERMISSION_EMAILS));
      }
    );
  };
};

//Function to delete user profile image
const deleteUserProfileImage = (userId) => {
  return (dispatch) => {
    return withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .deleteUserProfileImage(userId)
        .then(
          (response) => {
            customToast(successMessages.REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(success(response, loginConstants.LOGIN_USER));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Function to update user profile pic
const updateUserProfilePic = (data) => {
  return (dispatch) => {
    withSpinner(dispatch, USER_PERMISSION_DATA, () =>
      userPermissionsService
        .updateUserProfilePic(data)
        .then(
          (response) => {
            dispatch(success(response, loginConstants.USER_PROFILE_IMG));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, loginConstants.USER_PROFILE_IMG));
          }
        )
        .finally(() => {
          dispatch(storeActions.getAllBrands(true));
        })
    );
  };
};

const getUserById = (userId) => (dispatch) => {
  withSpinner(dispatch, USER_PERMISSION_DATA, () =>
    userPermissionsService
      .getUserById(userId)
      .then(
        (response) => dispatch(setUserData(response)),
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

const setUserData = (data) => (dispatch) => {
  dispatch(success(data, USER));
};

//Exporting mark actions for other files
export const userPermissionsActions = {
  getUsers,
  setUserData,
  updateUsers,
  getUserById,
  resetPassword,
  deleteUserDetails,
  addUserPermission,
  deleteUserProfileImage,
  resetPasswordResponseMsg,
  resendCreatePasswordEmail,
  getUserPermissionByBrandId,
  getUserPermissionByGroupId,
  getUserPermissionByManagerId,
  resetVerifyPassworddResponseMsg,
  updateUserProfilePic,
};
